import React, { FC, lazy, Suspense } from 'react';

import { WithContentstackPreviewProps } from './models';

const withContentstackPreview =
  <T extends WithContentstackPreviewProps>(
    WrappedComponent: React.FC<T>,
    contentType: string
  ) =>
  (props: T) => {
    if (process.env.GATSBY_CONTENTSTACK_LIVE_PREVIEW !== 'true') {
      return <WrappedComponent {...props} />;
    }

    const ContentstackPreviewComponent = lazy(
      () => import('./ContentstackPreview')
    );

    return (
      <Suspense fallback="Loading...">
        <ContentstackPreviewComponent
          {...props}
          WrappedComponent={
            WrappedComponent as FC<WithContentstackPreviewProps>
          }
          contentType={contentType}
        />
      </Suspense>
    );
  };

export default withContentstackPreview;
